<template>
	<Sidebar v-model:visible="visible" position="right" @hide="onHide">
		<div v-if="deviceDownloadLog" class="flex flex-col space-y-8">
			<div>
				<div class="flex items-center space-x-3">
					<h3 class="text-xl font-bold text-gray-900 sm:text-2xl">{{ deviceDownloadLog.device?.serial_number }}</h3>

					<FlatBadge :color="statuses[deviceDownloadLog.status]" :value="deviceDownloadLog.status"/>
				</div>
				<p class="text-sm text-gray-500">{{ deviceDownloadLog.device?.device_type?.name }}</p>
			</div>

			<div>
				<DescriptionList :title="$t('slide_overs.device_download_log_slide_over.information')" class="mt-2">
					<DescriptionListItem :term="$t('slide_overs.device_download_log_slide_over.initiated_by')" :details="deviceDownloadLog.initiated_by?.name"/>
					<DescriptionListItem :term="$t('slide_overs.device_download_log_slide_over.initiated_at')" :details="deviceDownloadLog.initiated_at ? $dateService(deviceDownloadLog.initiated_at).format('MMM DD, YYYY') : undefined"/>
					<DescriptionListItem :term="$t('slide_overs.device_download_log_slide_over.completed_at')" :details="deviceDownloadLog.completed_at ? $dateService(deviceDownloadLog.completed_at).format('MMM DD, YYYY') : undefined"/>
				</DescriptionList>
			</div>

			<div>
				<DescriptionList :title="$t('slide_overs.device_download_log_slide_over.device_details')" class="mt-2">
					<DescriptionListItem v-if="$auth.hasPermission('update:devices')" :term="$t('slide_overs.device_download_log_slide_over.serial_number')" :details="deviceDownloadLog.device?.serial_number" :to="{ name: 'admin.devices.device', params: { device: deviceDownloadLog.device_id } }"/>
					<DescriptionListItem v-else :term="$t('slide_overs.device_download_log_slide_over.serial_number')" :details="deviceDownloadLog.device?.serial_number"/>

					<DescriptionListItem :term="$t('slide_overs.device_download_log_slide_over.type')" :details="deviceDownloadLog.device?.device_type?.name"/>
					<DescriptionListItem :term="$t('slide_overs.device_download_log_slide_over.model')" :details="deviceDownloadLog.device?.device_model?.name"/>
					<DescriptionListItem :term="$t('slide_overs.device_download_log_slide_over.revision')" :details="deviceDownloadLog.device?.device_revision?.name"/>
				</DescriptionList>
			</div>

			<div>
				<DescriptionList :title="$t('slide_overs.device_download_log_slide_over.firmware_changes')" class="mt-2">
					<DescriptionListItem :term="$t('slide_overs.device_download_log_slide_over.version_number')">
						<ValueChange :from="deviceDownloadLog.current_firmware?.version_number" :to="deviceDownloadLog.target_firmware?.version_number"/>
					</DescriptionListItem>
					<DescriptionListItem :term="$t('slide_overs.device_download_log_slide_over.file_size')">
						<ValueChange :from="useFilesize(deviceDownloadLog.current_firmware?.size_bytes)" :to="useFilesize(deviceDownloadLog.target_firmware?.size_bytes)"/>
					</DescriptionListItem>
				</DescriptionList>
			</div>
		</div>
	</Sidebar>
</template>

<script>
import { mapStores } from "pinia";
import { useDeviceDownloadLogsStore } from "@/stores/deviceDownloadLogs.js";
import FlatBadge from "@/Components/Badges/FlatBadge.vue";
import { useFilesize } from "@/Composables/Filesize.js";
import DescriptionList from "@/Components/DescriptionList.vue";
import DescriptionListItem from "@/Components/DescriptionListItem.vue";
import ValueChange from "@/Components/ValueChange.vue";

export default {
	name: "DeviceDownloadLogSlideOver",
	components: {ValueChange, DescriptionListItem, DescriptionList, FlatBadge},
	data() {
		return {
			visible: false,
			params: {
				include: [
					'device.deviceType',
					'device.deviceModel',
					'device.deviceRevision',
					'currentFirmware',
					'targetFirmware',
					'initiatedBy',
				],
			},
			deviceDownloadLog: undefined,
			statuses: {
				PENDING: 'gray',
				INITIATED: 'yellow',
				COMPLETE: 'green',
				FAILED: 'red',
			},
		}
	},
	computed: {
		...mapStores(useDeviceDownloadLogsStore),
		title() {
			return this.deviceDownloadLog?.id
          ? this.$t('slide_overs.device_download_log_slide_over.download_log_x', { id: this.deviceDownloadLog?.id})
          : this.$t('slide_overs.device_download_log_slide_over.device_log');
		},
	},
	methods: {
		useFilesize,
		async showDeviceDownloadLog(deviceDownloadLog) {
			if (!deviceDownloadLog)
				return;

			this.deviceDownloadLog = deviceDownloadLog;
			this.visible = true;
			this.deviceDownloadLog = await this.deviceDownloadLogsStore.showDeviceDownloadLog(deviceDownloadLog.id, this.params);
		},
		onHide() {
			this.deviceDownloadLog = undefined;
		},
	},
}
</script>